module.exports = __webpack_public_path__ + "static/media/no_prediction_market.6b7cf01e.png";